import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: '1IZk+9',
    defaultMessage: 'Find your IBM Cloud® location',
  },
  filterLabel: {
    id: 'VzyqIZ',
    defaultMessage: 'Filter by geography',
  },
  locationLabel: {
    id: 'rvirM2',
    defaultMessage: 'Location',
  },
  previousPage: {
    id: 'k9hDFZ',
    defaultMessage: 'Previous page',
  },
  nextPage: {
    id: 'rBj9Ib',
    defaultMessage: 'Next page',
  },
  emea: {
    id: 'V602AA',
    defaultMessage: 'EMEA',
  },
  apac: {
    id: '9DIA+5',
    defaultMessage: 'APAC',
  },
  americas: {
    id: 'saJth7',
    defaultMessage: 'Americas',
  },
  row11: {
    id: '5/ZVcj',
    defaultMessage: 'Miami',
  },
  row12: {
    id: 'WaZD9I',
    defaultMessage: 'Toronto',
  },
  firstTitle: {
    id: 'V5MN6t',
    defaultMessage: 'Multi-Zone Region',
  },
  row31: {
    id: '0/kcGP',
    defaultMessage: 'Perth',
  },
  row10: {
    id: 'NwfCZN',
    defaultMessage: 'New York City',
  },
  row15: {
    id: 'L5VdMS',
    defaultMessage: 'Frankfurt',
  },
  row16: {
    id: 'deoXOL',
    defaultMessage: 'Madrid',
  },
  row13: {
    id: '7z9Vs4',
    defaultMessage: 'Montreal',
  },
  row14: {
    id: '7ybQi0',
    defaultMessage: 'São Paulo',
  },
  row30: {
    id: 'wYcYcy',
    defaultMessage: 'Melbourne',
  },
  thirdTitle: {
    id: 'yHztb1',
    defaultMessage: 'Federal Data Center',
  },
  row28: {
    id: 'OgF6Am',
    defaultMessage: 'Mumbai',
  },
  row: {
    id: 'ftH7ii',
    defaultMessage: 'Stockholm',
  },
  row29: {
    id: 'Dg2c3+',
    defaultMessage: 'Sydney',
  },
  row22: {
    id: '7I4cik',
    defaultMessage: 'Osaka',
  },
  row23: {
    id: 'JFYhZv',
    defaultMessage: 'Hong Kong',
  },
  row1: {
    id: 'bOaynN',
    defaultMessage: 'Washington, DC',
  },
  row20: {
    id: 'LKUXOw',
    defaultMessage: 'Milan',
  },
  row21: {
    id: 'mWF7RS',
    defaultMessage: 'Tokyo',
  },
  row26: {
    id: 'rhaGlx',
    defaultMessage: 'Singapore',
  },
  row27: {
    id: 'Hl6eet',
    defaultMessage: 'Chennai',
  },
  row24: {
    id: 'sKrQGP',
    defaultMessage: 'Taipei',
  },
  row25: {
    id: 'wFfaY4',
    defaultMessage: 'Seoul',
  },
  row7: {
    id: 'qr2sKL',
    defaultMessage: 'Denver',
  },
  row6: {
    id: 'i1GA35',
    defaultMessage: 'Seattle',
  },
  row9: {
    id: 'ZxG5bx',
    defaultMessage: 'Atlanta',
  },
  row8: {
    id: 'JVuVOx',
    defaultMessage: 'Chicago',
  },
  row3: {
    id: 'vnNLRC',
    defaultMessage: 'San Jose',
  },
  row2: {
    id: 'U+wBOG',
    defaultMessage: 'Dallas',
  },
  row5: {
    id: 'Eww+Ll',
    defaultMessage: 'Los Angeles',
  },
  secondTitle: {
    id: '3i7Hau',
    defaultMessage: 'Data Center',
  },
  row19: {
    id: 'qFismH',
    defaultMessage: 'Amsterdam',
  },
  row17: {
    id: 'YekgnB',
    defaultMessage: 'London',
  },
  row18: {
    id: 'UfMD1l',
    defaultMessage: 'Paris',
  },
  fourthTitle: {
    id: 'EpJRRQ',
    defaultMessage: 'Network PoP',
  },
  oslo: {
    id: '91KBuU',
    defaultMessage: 'Oslo',
  },
  stockholm: {
    id: 'ftH7ii',
    defaultMessage: 'Stockholm',
  },
});

export default messages;
